import { Typography } from 'antd';

export const Commentwaitingproject = ({ waitingLineManagercomment,tableTitle }) => {
 

const isWaitingApprovalCommentPresent = tableTitle === undefined ? false : waitingLineManagercomment.some(check => check.isWaiting);



return (
  <>
  
  <Typography.Paragraph style={{ textAlign: 'center' }} ><strong> Line manager Comments(Waiting): </strong></Typography.Paragraph>
  {waitingLineManagercomment.map((timesheet,index)=>{
      return (
        <Typography.Paragraph  key={index} style={{ textAlign: 'center' }}>
        <p>{timesheet.lineManagerComments}</p> 
        
        </Typography.Paragraph>
      )
    })}
  <Typography.Paragraph className='hasWaitingComment' >
  {isWaitingApprovalCommentPresent ?<p>Waiting Project hours have already been approved</p>:""}
  </Typography.Paragraph>
  </>
  )
    
  
};
